import { useState, useEffect } from "react";
import axios from "axios";
import { Alert, Modal, Col, Row, Form, Button } from "react-bootstrap";

// to-do: resta poder Crear

const ExamModal = (props) => {
  const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";
  const ls = require("localstorage-ttl");

  const [isLoading, setLoading] = useState(false);
  const [isSearchingUser, setSearchingUser] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [userId, setUserId] = useState();
  const [docNumber, setDocNumber] = useState();
  const [fullname, setFullname] = useState();

  const [grade, setGrade] = useState();
  const [dojo, setDojo] = useState();
  const [examDate, setExamDate] = useState();
  const [idAikikai, setIdAikikai] = useState("");
  const [dateAikikai, setDateAikikai] = useState("");
  const [responsibleDocNumber, setResponsibleDocNumber] = useState();
  const [createdByUser, setCreatedByUser] = useState();

  const exam = props.exam;
  const token = JSON.parse(ls.get("jwt"));

  var moment = require("moment");

  useEffect(() => {
    if (exam) {
      setDocNumber(exam.attributes.docNumber);
      setGrade(exam.attributes.grade_id);
      setDojo(exam.attributes.dojo_id);
      setCreatedByUser(exam.attributes.createdByUser);
      setIdAikikai(exam.attributes.idAikikai);
      setDateAikikai(
        exam.attributes.dateAikikai !== "" ? exam.attributes.dateAikikai : ""
      );
      setExamDate(exam.attributes.date);
      setResponsibleDocNumber(exam.attributes.responsibleDocNumber);

      // si es import no tiene tempUser
      const tempUser = exam.attributes.tempUser;
      if (tempUser?.data?.id) {
        setUserId(tempUser.data.id);
        setDocNumber(tempUser.data.attributes.docNumber);
        setFullname(
          tempUser.data.attributes.name +
            " " +
            tempUser.data.attributes.lastname
        );
      } else {
        setUserId(null);
        setFullname(exam.fullname);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function isIncomplete() {
    return (
      !docNumber ||
      docNumber === "" ||
      !fullname ||
      fullname === "" ||
      !dojo ||
      dojo === "" ||
      !grade ||
      grade === "" ||
      !responsibleDocNumber ||
      responsibleDocNumber === ""
    );
  }

  const headerRequest = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();

    if (
      dateAikikai != "" &&
      moment(examDate, true).diff(moment(dateAikikai, true), "days") > 0
    ) {
      setLoading(false);
      setErrorMessage("Fecha Aikikai debe ser posterior al Examen.");
      return;
    }

    const reqExam = {
      data: {
        docNumber,
        date: examDate,
        grade_id: grade,
        dojo_id: dojo,
        idAikikai,
        dateAikikai: dateAikikai !== "" ? dateAikikai : null,
        responsibleDocNumber,
        state: "NEW",
        tempUser: userId,
        createdByUser,
      },
    };

    // Si existe en temp-users hacer PUT, sino POST
    if (exam) {
      await axios
        .put(`${API_URL}/temp-exams/${exam.id}`, reqExam, headerRequest)
        .then(() => {
          setLoading(false);
          props.onHide(true);
        })
        .catch((error) => {
          setLoading(false);
          console.log("Error with put temp-exams:", error.response);
          setErrorMessage("Hubo un error, intente nuevamente.");
          return;
        });
    } else {
      await axios
        .post(`${API_URL}/temp-exams`, reqExam, headerRequest)
        .then(() => {
          setLoading(false);
          props.onHide(true);
        })
        .catch((error) => {
          setLoading(false);
          console.log("Error with post temp-exams:", error.response);
          setErrorMessage("Hubo un error, intente nuevamente.");
          return;
        });
    }
  };

  return (
    <Modal
      {...props}
      backdrop="static"
      aria-labelledby="contained-modal-title-vcenter"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {exam ? "Editar" : "Crear"} Exámen
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="show-grid">
        <Form onSubmit={(e) => handleSubmit(e)}>
          <Row className="mb-1">
            <h5>Datos del Alumno</h5>
          </Row>
          <Row className="mb-3">
            <Form.Group
              as={Col}
              controlId="formDocNumber"
              className="has-feedback mw160"
            >
              <Form.Label>Núm. Documento</Form.Label>
              <Form.Control readOnly disabled value={docNumber} />
              {isSearchingUser ? (
                <span className="loading form-control-feedback"></span>
              ) : null}
            </Form.Group>
            <Form.Group as={Col} controlId="formLastname">
              <Form.Label>Nombre</Form.Label>
              <Form.Control readOnly disabled value={fullname} />
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} controlId="formDojo">
              <Form.Label>Dojo</Form.Label>
              <Form.Select
                value={dojo}
                onChange={(e) => setDojo(e.target.value)}
              >
                <option>seleccione dojo</option>
                {props.dojos.map((item) => {
                  return (
                    <option key={item.id} value={item.id}>
                      {item.attributes.name}
                    </option>
                  );
                })}
              </Form.Select>
            </Form.Group>
          </Row>
          <hr />
          <Row className="mb-1">
            <h5>Datos del Exámen</h5>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} controlId="formGrade">
              <Form.Label>Graduación</Form.Label>
              {props.grades.length > 0 ? (
                <Form.Select
                  value={grade}
                  onChange={(e) => setGrade(e.target.value)}
                >
                  {props.grades.map((item) => {
                    return (
                      <option key={item.id} value={item.id}>
                        {item.attributes.name}
                      </option>
                    );
                  })}
                </Form.Select>
              ) : (
                <Form.Control
                  readOnly
                  isInvalid
                  disabled
                  value="Sin opciones"
                />
              )}
            </Form.Group>

            <Form.Group as={Col} controlId="formBirthDate">
              <Form.Label>Fecha de Examen</Form.Label>
              <Form.Control
                type="date"
                name="examDate"
                defaultValue={examDate}
                onChange={(e) => setExamDate(e.target.value)}
              />
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} controlId="formResponsibleDocNumber">
              <Form.Label>Examinador</Form.Label>
              <Form.Select
                value={responsibleDocNumber}
                onChange={(e) => setResponsibleDocNumber(e.target.value)}
              >
                <option>seleccione examinador</option>
                {props.teachers.map((item) => {
                  return (
                    <option
                      key={item.attributes.docNumber}
                      value={item.attributes.docNumber}
                    >
                      {item.attributes.name}
                    </option>
                  );
                })}
              </Form.Select>
            </Form.Group>
          </Row>

          <Row className="mb-1">
            <h6>Datos de la Yudansha</h6>
            <p>Puede cargar los datos que se registraron en la yudansha</p>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} controlId="formGrade">
              <Form.Label>Identificador</Form.Label>
              <Form.Control
                type="text"
                placeholder="Identificador"
                value={idAikikai}
                inputMode="numeric"
                pattern="[0-9]*"
                onChange={(e) => setIdAikikai(e.target.value)}
              />
            </Form.Group>

            <Form.Group as={Col} controlId="formBirthDate">
              <Form.Label>Fecha Aikikai</Form.Label>
              <Form.Control
                type="date"
                name="dateAikikai"
                value={dateAikikai}
                onChange={(e) => setDateAikikai(e.target.value)}
              />
            </Form.Group>
          </Row>

          <Button
            variant="primary"
            type="submit"
            disabled={isLoading || isIncomplete()}
          >
            {isLoading ? "Procesando…" : "GRABAR"}
          </Button>
          {errorMessage ? (
            <Alert className="mt-3" variant="danger">
              {errorMessage}
            </Alert>
          ) : (
            <></>
          )}
        </Form>
      </Modal.Body>
    </Modal>
  );
};
export default ExamModal;
